import { Fragment } from "react";

/**
 * Renders the line breaks an editor typed into a CMS string, on one breakpoint only: the designs
 * break some copy by hand on mobile (or desktop) and let it wrap freely on the other.
 */
export default function BreakLines({ text, on }: { text?: string; on: "mobile" | "desktop" }) {
  if (!text) return null;
  return (
    <>
      {text.split("\n").map((line, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <>
              <br className={on === "mobile" ? "lg:hidden" : "hidden lg:inline"} />{" "}
            </>
          )}
          {line.trim()}
        </Fragment>
      ))}
    </>
  );
}
